import { ModuleWithProviders, NgModule, Optional } from '@angular/core';

import { DevFlag } from '@recruitee/dev-flags-data';

import { AnalyticsGlobal } from './analytics-global';
import { AnalyticsRouteTracker } from './analytics-route.tracker';
import { AnalyticsSegmentClient } from './analytics-segment-client';
import { TrackDirective } from './analytics.directive';
import {
  Analytics,
  AnalyticsConfig,
  PageTrackParamsSanitizerFn,
  SegmentClientOptions,
} from './analytics.types';

@NgModule({
  imports: [TrackDirective],
  providers: [],
  exports: [TrackDirective],
})
export class RtAnalyticsModule {
  public static forRoot(opts: {
    segmentKey?: string;
    segmentOptions?: SegmentClientOptions;
    debug?: boolean;
    disable?: boolean;
    trackRouteChange: boolean;
    waitForIdentify?: boolean;
    pageTrackParamsSanitizer?: PageTrackParamsSanitizerFn;
    requiredFeatureFlag?: DevFlag;
  }): ModuleWithProviders<RtAnalyticsModule> {
    return {
      ngModule: RtAnalyticsModule,
      providers: [
        AnalyticsSegmentClient,
        {
          provide: Analytics,
          useClass: AnalyticsGlobal,
        },
        {
          provide: AnalyticsConfig,
          useValue: new AnalyticsConfig(opts),
        },
        ...(opts.trackRouteChange
          ? [
              {
                provide: AnalyticsRouteTracker,
              },
            ]
          : []),
      ],
    };
  }

  constructor(
    // for eager initialization purposes
    @Optional() private routeTracker: AnalyticsRouteTracker,
  ) {}
}
